import { render } from "./Address.vue?vue&type=template&id=509cb62a&scoped=true"
import script from "./Address.vue?vue&type=script&lang=js"
export * from "./Address.vue?vue&type=script&lang=js"

import "./Address.vue?vue&type=style&index=0&id=509cb62a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-509cb62a"]])

export default __exports__